



























import { Component, Vue, Prop } from 'vue-property-decorator'
import { Project } from '../types'
@Component({ components: {} })
export default class extends Vue {
  @Prop()
  showRole!: boolean

  @Prop()
  nameSize!: string

  @Prop()
  public project!: Project
}
